function exists(input) {
  return input !== null && input !== void 0;
}

export { exists };
//# sourceMappingURL=exists.mjs.map
